import { Check } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { Reveal, Overline } from './motion';

export const BftAutomation = () => {
  const { t } = useLanguage();
  const b = t('bft');

  return (
    <section data-testid="bft-section" className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-28">
      <Reveal className="mb-12">
        <Overline className="mb-4">{b.overline}</Overline>
        <h2 className="font-display text-3xl md:text-4xl font-medium tracking-tight mb-4">{b.title}</h2>
        <p className="text-smoke max-w-2xl leading-relaxed">{b.desc}</p>
      </Reveal>

      <Reveal className="mb-14">
        <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-smoke mb-6">{b.motorsTitle}</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {b.motors.map((m, i) => (
            <div
              key={m.name}
              data-testid={`bft-motor-${i}`}
              className="bg-surface border border-line/10 rounded-[2rem] p-8 hover:shadow-[0_24px_70px_rgba(24,26,32,0.10)] hover:-translate-y-1 transition-all duration-500"
            >
              <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-accent mb-3">BFT · 24 V</p>
              <h3 className="font-display text-xl md:text-2xl font-medium mb-6">{m.name}</h3>
              <ul className="space-y-3">
                {m.specs.map((s, j) => (
                  <li key={j} className="flex items-start gap-3 text-sm text-smoke leading-relaxed">
                    <Check size={15} className="text-accent shrink-0 mt-0.5" />
                    <span>{s}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal>
        <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-smoke mb-6">{b.accTitle}</p>
        <div className="flex flex-wrap gap-3">
          {b.accessories.map((a, i) => (
            <span
              key={i}
              data-testid={`bft-accessory-${i}`}
              className="text-xs md:text-sm bg-surface border border-line/15 rounded-full px-4 py-2 text-smoke hover:border-accent hover:text-ink transition-colors duration-300"
            >
              {a}
            </span>
          ))}
        </div>
        <p className="text-smoke text-sm mt-8 border-l-2 border-accent pl-4">{b.note}</p>
      </Reveal>
    </section>
  );
};
